// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-checklist-checkpoint-view {
  display: block;
}
fi-checklist-checkpoint-view .checkpoint-name,
fi-checklist-checkpoint-view .checkpoint-description {
  font-size: 16px;
}

.checkpoint-additional-info {
  margin-top: 20px;
}

.checkpoint-qr-code-required {
  color: var(--fi-color-red);
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist/checkpoint-view/checkpoint-view.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AACI;;EAEI,eAAA;AACR;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,0BAAA;AAAJ","sourcesContent":["fi-checklist-checkpoint-view {\r\n    display: block;\r\n\r\n    .checkpoint-name,\r\n    .checkpoint-description {\r\n        font-size: 16px;\r\n    }\r\n}\r\n\r\n.checkpoint-additional-info {\r\n    margin-top: 20px;\r\n}\r\n\r\n.checkpoint-qr-code-required {\r\n    color: var(--fi-color-red);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
